import { Badge as BadgeA } from 'antd';
import cn from 'classnames';
import type { ComponentProps } from 'react';

type P = { display?: 'flex' } & ComponentProps<typeof BadgeA>;

const Badge = ({ className, display, ...rest }: P) => (
  <BadgeA {...rest} className={cn(className, 'ui-badge', { 'ui-badge--display-flex': display === 'flex' })} />
);

export default Badge;
